import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_LOCAL_API_REQUESTS } from './constants';

export const patchRenologDevice = async (projectId, deviceId, deviceData) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `projects/${projectId}/renolog/devices/${deviceId}`,
    body: deviceData,
    isLocalApiRequest: RENOLOG_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
